document.addEventListener("DOMContentLoaded", function() {
    // Define the new URLs
    var newURLs = {
        "/collections/hair": "/pages/services#hairs-section",
        "/collections/nails": "/pages/services#nails-section",
        "/collections/face": "/pages/services#faces-section",
        "/collections/body": "/pages/services#bodys-section"
    };

    // Select all anchor elements with class "collection-item"
    var collectionItems = document.querySelectorAll('.collection-item');

    // Function to handle redirection and smooth scrolling
    function redirectToNewURL(event) {
        event.preventDefault(); // Prevent default anchor behavior
        var oldHref = this.getAttribute('href'); // Get the original href
        if (newURLs.hasOwnProperty(oldHref)) {
            var newHref = newURLs[oldHref]; // Get the new href
            // Redirect to the new URL
            window.location.href = newHref;
            // Scroll to the target section after a slight delay
            setTimeout(function() {
                var sectionId = newHref.substring(newHref.indexOf("#"));
                var targetSection = document.querySelector(sectionId);
                if (targetSection) {
                    var scrollOffset = targetSection.getBoundingClientRect().top + window.pageYOffset - 550;
                    window.scrollTo({ top: scrollOffset, behavior: 'smooth' });
                }
            }, 500); // Adjust the delay value as needed
        }
    }

    // Loop through each anchor element
    collectionItems.forEach(function(item) {
        // Attach click event listener to each anchor element
        item.addEventListener('click', redirectToNewURL);
    });
});
